/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether an entity/row selection is required or taken into account.
 * @export
 */
export const EntitySelectionConstants = {
    None: 'None',
    Optional: 'Optional',
    Required: 'Required'
} as const;
export type EntitySelectionConstants = typeof EntitySelectionConstants[keyof typeof EntitySelectionConstants];


export function EntitySelectionConstantsFromJSON(json: any): EntitySelectionConstants {
    return EntitySelectionConstantsFromJSONTyped(json, false);
}

export function EntitySelectionConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntitySelectionConstants {
    return json as EntitySelectionConstants;
}

export function EntitySelectionConstantsToJSON(value?: EntitySelectionConstants | null): any {
    return value as any;
}

